"use client";
import { useMemo } from "react";
import { motion } from "framer-motion";
import ScrollAnimationWrapper from "@/components/ScrollAnimationWrapper";
import {
  getScrollAnimation,
  getScrollAnimationRev,
} from "@/utils/getScrollAnimation";
import Image1 from "@/assets/image1.jpeg";
import Image2 from "@/assets/image2.jpeg";
import Image3 from "@/assets/image3.jpeg";
import Image4 from "@/assets/image4.jpeg";
import Image5 from "@/assets/image5.jpeg";
import Image6 from "@/assets/image6.jpeg";
import Image7 from "@/assets/image7.jpeg";

import Google from "@/assets/Google_Play.png";
import Apple from "@/assets/App_Store.png";
import { useTranslations } from "@/i18n/provider";
import { localizePath } from "@/i18n/pathnames";
import { useLocalizedRouter } from "@/i18n/navigation";

// const images = [Image1, Image2, Image3, Image4, Image5, Image6, Image7];

export const Community = () => {
  const t = useTranslations();
  const scrollAnimation = useMemo(() => getScrollAnimation(), []);
  const scrollAnimation2 = useMemo(() => getScrollAnimationRev(), []);
  const router = useLocalizedRouter();

  return (
    <section className=" bg-dark flex flex-col justify-center ">
      <div className="mx-5 lg:mx-0 pt-20 pb-7">
        <ScrollAnimationWrapper>
          <motion.div
            variants={scrollAnimation}
            className="container border p-5 md:p-10  bg-green200 border-green rounded-xl"
          >
            <ScrollAnimationWrapper>
              {/* ROW ONE */}
              <div className="flex items-center justify-center md:gap-5">
                {/* IMAGE ONE */}
                <motion.div
                  custom={{ duration: 1 }}
                  variants={scrollAnimation}
                  className="mt-5 rounded-full overflow-hidden p-[1px] bg-gradient-to-r from-[#4ade80] via-[#16a34a] to-[#14532d]"
                >
                  <div className="rounded-full overflow-hidden bg-gray-900 md:p-[4px]">
                    <img
                      src={Image1.src}
                      alt={`Image `}
                      className="w-14 h-14 md:w-28 md:h-28 object-cover rounded-full"
                    />
                  </div>
                </motion.div>

                {/* IMAGE TWO */}
                <motion.div
                  custom={{ duration: 2 }}
                  variants={scrollAnimation}
                  className="mb-2 md:mb-7 rounded-full overflow-hidden p-[1px] bg-gradient-to-r from-[#4ade80] via-[#16a34a] to-[#14532d]"
                >
                  <div className="rounded-full overflow-hidden bg-gray-900 md:p-[4px] ">
                    <img
                      src={Image2.src}
                      alt={`Image `}
                      className="w-14 h-14 md:w-32 md:h-32 object-cover rounded-full"
                    />
                  </div>
                </motion.div>

                {/* IMAGE THREE */}
                <motion.div
                  custom={{ duration: 2 }}
                  variants={scrollAnimation}
                  className="mt-5 rounded-full overflow-hidden p-[1px] bg-gradient-to-r from-[#4ade80] via-[#16a34a] to-[#14532d]"
                >
                  <div className="rounded-full overflow-hidden bg-gray-900 md:p-[4px]">
                    <img
                      src={"/assets/images/cy2.jpeg"}
                      alt={`Image `}
                      className="w-14 h-14 md:w-28 md:h-28 object-cover rounded-full"
                    />
                  </div>
                </motion.div>

                {/* IMAGE FOUR */}
                <motion.div
                  custom={{ duration: 2 }}
                  variants={scrollAnimation}
                  className="mb-1 md:mb-7 rounded-full overflow-hidden p-[1px] bg-gradient-to-r from-[#4ade80] via-[#16a34a] to-[#14532d]"
                >
                  <div className="rounded-full overflow-hidden bg-gray-900 md:p-[4px] ">
                    <img
                      src={Image4.src}
                      alt={`Image `}
                      className="w-14 h-14 md:w-32 md:h-32 object-cover rounded-full"
                    />
                  </div>
                </motion.div>

                {/* IMAGE FIVE */}
                <motion.div
                  custom={{ duration: 2 }}
                  variants={scrollAnimation}
                  className="mt-5 rounded-full overflow-hidden p-[1px] bg-gradient-to-r from-[#4ade80] via-[#16a34a] to-[#14532d]"
                >
                  <div className="rounded-full overflow-hidden bg-gray-900 md:p-[4px]">
                    <img
                      src={Image5.src}
                      alt={`Image `}
                      className="w-12 h-12 md:w-28 md:h-28 object-cover rounded-full"
                    />
                  </div>
                </motion.div>
              </div>
            </ScrollAnimationWrapper>

            {/* ROW TWO */}
            <ScrollAnimationWrapper>
              <div className=" flex items-center justify-center md:gap-5 mb-5 -mt-2 md:-mt-6">
                {/* IMAGE ONE */}
                <motion.div
                  custom={{ duration: 2 }}
                  variants={scrollAnimation}
                  className="mb-5 rounded-full overflow-hidden p-[1px] bg-gradient-to-r from-[#4ade80] via-[#16a34a] to-[#14532d]"
                >
                  <div className="rounded-full overflow-hidden bg-gray-900 md:p-[4px]">
                    <img
                      src={Image6.src}
                      alt={`Image `}
                      className="w-20 h-20 md:w-36 md:h-36 object-cover rounded-full"
                    />
                  </div>
                </motion.div>

                {/* IMAGE TWO */}
                <motion.div
                  custom={{ duration: 2 }}
                  variants={scrollAnimation}
                  className="mt-7 rounded-full overflow-hidden p-[1px] bg-gradient-to-r from-[#4ade80] via-[#16a34a] to-[#14532d]"
                >
                  <div className="rounded-full overflow-hidden bg-gray-900 md:p-[4px] ">
                    <img
                      src={"/assets/images/cy1.png"}
                      alt={`Image `}
                      className="w-24 h-24 md:w-48 md:h-48 object-cover rounded-full"
                    />
                  </div>
                </motion.div>

                {/* IMAGE THREE */}
                <motion.div
                  custom={{ duration: 2 }}
                  variants={scrollAnimation}
                  className="mb-5 rounded-full overflow-hidden p-[1px] bg-gradient-to-r from-[#4ade80] via-[#16a34a] to-[#14532d]"
                >
                  <div className="rounded-full overflow-hidden bg-gray-900 md:p-[4px]">
                    <img
                      src={Image3.src}
                      alt={`Image `}
                      className="w-20 h-20 md:w-36 md:h-36 object-cover rounded-full"
                    />
                  </div>
                </motion.div>
              </div>
            </ScrollAnimationWrapper>

            <ScrollAnimationWrapper>
              <h1
                // variants={scrollAnimation}
                // custom={{ duration: 9 }}
                className="text-2xl md:text-4xl text-center font-bold text-black pb-5"
              >
                {t("home.communityTitle")}
              </h1>

              <h1
                // variants={scrollAnimation}
                // custom={{ duration: 10 }}
                className="text-lg md:text-xl text-center font-semibold text-black pb-10"
              >
                {t("home.communityLead")}{" "}
                <a
                  href={localizePath("/waitlist", router.locale)}
                  className="bg-clip-text text-transparent bg-gradient-to-r from-[#268348] to-[#7bf1aa]"
                >
                  Cliqbox
                </a>{" "}
                {t("home.communityAfterBrand")}
              </h1>
            </ScrollAnimationWrapper>
          </motion.div>
        </ScrollAnimationWrapper>
        <ScrollAnimationWrapper>
          {/* <div className="flex justify-center items-center gap-4 mt-10">
            <a
              href="/waitlist"
              // href="https://play.google.com/store/apps/details?id=com.ajobox.app"
              // target="_blank"
              rel="noopener noreferrer"
            >
              <motion.img
                variants={scrollAnimation}
                src={Google.src}
                alt="Google Store"
                width={200}
              />
            </a>
            <a
              href="/waitlist"
              // href="https://apps.apple.com/ng/app/ajobox/id1607163500"
              // target="_blank"
              rel="noopener noreferrer"
            >
              <motion.img
                variants={scrollAnimation}
                src={Apple.src}
                alt="Apple Store"
                width={200}
              />
            </a>
          </div> */}

          <div className="flex justify-center items-center gap-4 mt-10">
            <button
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.ajobox.app&pcampaignid=web_share",
                  "_blank"
                )
              }
            >
              <motion.img
                variants={scrollAnimation}
                src={Google.src}
                alt="Google Store"
                width={200}
              />
            </button>
            <button
              onClick={() =>
                window.open(
                  "https://apps.apple.com/us/app/cliqbox/id1607163500",
                  "_blank"
                )
              }
            >
              <motion.img
                variants={scrollAnimation}
                src={Apple.src}
                alt="Apple Store"
                width={200}
              />
            </button>
          </div>
        </ScrollAnimationWrapper>
      </div>
    </section>
  );
};

{
  /* <div className="flex flex-wrap justify-center gap-4 mb-12">
              {images.map((src, index) => (
                <motion.div
                  key={index}
                  custom={{ duration: 2 + index }}
                  variants={scrollAnimation}
                  className="rounded-full overflow-hidden p-[1px] bg-gradient-to-r from-[#4ade80] via-[#16a34a] to-[#14532d]"
                >
                  <div className="rounded-full overflow-hidden bg-gray-900 p-[4px]">
                    <img
                      src={src.src}
                      alt={`Image ${index}`}
                      className="w-20 h-20 md:w-28 md:h-28 object-cover rounded-full"
                    />
                  </div>
                </motion.div>
              ))}
            </div> */
}
